import React from 'react';
import {Form, Input, Row, Col} from 'antd';
import {userRols} from "../../../helpers/userRols";

const HotelFormData = ({role}) => {
  return (
    <Row gutter={16}>
      <Col xs={24} md={12}>
        <Form.Item
          name={["metadata", "siteUrl"]}
          label="Уебсайт"
          rules={[{required: true, message: 'Моля, въведи уебсайт'}]}
        >
          <Input placeholder="Уебсайт"/>
        </Form.Item>
      </Col>
      {/*<Col xs={24} md={12}>*/}
      {/*  <Form.Item*/}
      {/*    name={["metadata", "dateOfCourtRegistration"]}*/}
      {/*    label="Date Of Court Registration"*/}
      {/*    rules={[{required: true, message: 'Please write date of court registration'}]}*/}
      {/*  >*/}
      {/*    <Input placeholder="Date Of Court Registration"/>*/}
      {/*  </Form.Item>*/}
      {/*</Col>*/}
      <Col xs={24} md={12}>
        <Form.Item
          name={["metadata", "businessName"]}
          label={userRols.shelter === role ? 'Име на организацията' :"Име на хотела"}
          rules={[{required: true, message: userRols.shelter === role ? 'Моля, въведи име на организацията' : 'Моля, въведи име на хотела'}]}
        >
          <Input placeholder="Уебсайт"/>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default HotelFormData;
